module.exports = __webpack_public_path__ + "img/Roof.95f2d91a.png";